import styles from './App.module.scss'
import Contact from './Contact';
import Description from './Description';
import Footer from './Footer';
import Header from './Header';
import Services from './Services';
import Team from './Team';
import { useRef } from 'react';
import Work from './Work';

function App() {
  const workRef = useRef<HTMLDivElement>(null);
  const contactRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <Header workRef={workRef} contactRef={contactRef} />
      <div className={styles.app}>
        <img src='images/background.png' className={styles.image} alt='' aria-hidden='true' />
        <Description />
        <Services />
        <Team />
        <Work workRef={workRef} />
        <Contact contactRef={contactRef} />
        <Footer />
      </div>
    </>
  );
}

export default App;
